'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M0 64h1024v128h-1024zM0 576h1024v128h-1024zM0 320h1024v128h-1024zM0 832h1024v128h-1024z' })
    ));
};